module.exports = __webpack_public_path__ + "static/media/close.c394580b.svg";